import { Typography } from 'antd';

import { cn } from '@/lib/cn';

type TitleProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
};

export const Title = ({ children, className, id }: TitleProps) => {
  // Keep the level-3 visual size, but expose it as the page's top-level heading
  // (each wizard step renders a single primary title, with no h1/h2 above it).
  return (
    <Typography.Title level={3} aria-level={1} id={id} className={cn('mb-2', className)}>
      {children}
    </Typography.Title>
  );
};
